import { component } from 'picoapp';
import Drawer from '../../../js/utils/drawer';

export default component(async (node) => {
  const drawerBtn = node.querySelector('.js-drawerBtn');
  const drawerElement = node.querySelector('.js-drawer');
  const closeBtn = drawerElement.querySelector('.js-closeBtn');

  const init = () => {
    document.body.appendChild(drawerElement);
    const drawer = Drawer(drawerElement);

    drawerBtn.addEventListener('click', () => drawer.open());
    closeBtn.addEventListener('click', () => drawer.close());
  };

  init();
});
